import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../';
import { PaperSet } from '../../core-modules/model';
import { ItemsCheckout } from '../../core-modules/model/itemsCheckout';
import { CookieManagerService } from './cookie-manager.service';
import { CookieNames } from '../../core-modules/constant';
declare var $: any;

@Injectable()
export class ShoppingCartService {
  public itemsCheckout: Subject<ItemsCheckout[]> = new BehaviorSubject<ItemsCheckout[]>(null);
  public itemsIDArray : string [] = [];
  public totalPrice: number = 0;
  public timer: any;
  public isLoad : Subject<boolean> = new BehaviorSubject<boolean>(false);
  public loginUser: string = CookieNames.userobj;
  constructor(
    private cookieManagerService: CookieManagerService,
  ) 
  {
   
  }

  changeButtonIcon(itemId) {
    this.allStorage();
    let status : string;
    let click : boolean = (this.itemsIDArray.indexOf(itemId)>-1);
    if (click) {
      status = 'Remove';
    }
    else {
      status = 'Buy Now'
    }
    return status;
  }

  changeButtonColor(itemId){
    this.allStorage();
    let color : string;
    let click : boolean = (this.itemsIDArray.indexOf(itemId)>-1);
    if (click) {
      color = 'svg-secondary-button';
    }
    else {
      color = 'svg-primary-button'
    }
    return color;
  }

  storeItemsCheckout(item: PaperSet) {
    let itemsCheckout: ItemsCheckout = new ItemsCheckout();
    itemsCheckout.id = item._id;
    itemsCheckout.price = item.price;
    itemsCheckout.title = item.title;
    itemsCheckout.createdBy = item.getCreatedBy();
    itemsCheckout.done = true;
    let userObj = this.cookieManagerService.getCookie(this.loginUser, false);
    if(userObj){
      itemsCheckout.islogged = true;
    }
    localStorage.setItem('item-' + item._id, JSON.stringify(itemsCheckout));
    let allItems = this.allStorage();
    let items: any = allItems;
    this.itemsCheckout.next(items);
  }

  removeItemsCheckout(item_id) {
    localStorage.removeItem('item-' + item_id);
    let allItems = this.allStorage();
    let items: any = allItems;
    this.itemsCheckout.next(items);
  }

  getItemsLength(): Observable<any> {
    return this.itemsCheckout.asObservable();
  }

  getItemsIDArray(){
    return this.itemsIDArray;
  }

  returnTotalPrice() {
    return this.totalPrice;
  }

  allStorage() {
    var values = new Array<ItemsCheckout>(),
      keys = Object.keys(localStorage),
      i = keys.length;

    keys.sort((a: any, b: any) => {
      return b.replace('item-', '') - a.replace('item-', '');
    });

    let idArray : string [] = [];
    let price: number = 0;
    if (!i) {
      this.totalPrice = 0;
    }
    
    while (i--) {
      if (keys[i].includes('item-')) {
        let item = JSON.parse(localStorage.getItem(keys[i]));
        price = price + item.price;
        idArray.push(item.id);
        values.push(new ItemsCheckout(item));
      }
      this.totalPrice = price;
    }
    this.itemsIDArray = idArray;
    return values;
  }

  resetTimer() {
    clearTimeout(this.timer);
    $("#hu").show(); 
    this.timer = setTimeout(() => {
      $("#hu").hide(); 
    }, 5000);
  }
  
  clearTimer() {
    clearTimeout(this.timer);
  }

  /**
   * kaushalya
   * 2017-10-23
   * remove the all shoping details
   */
  clearAll(){ 
   this.allStorage().forEach(element => {
      this.removeItemsCheckout(element['id']);
    });
  }

  clearPersonelItems(){ 
    this.allStorage().forEach(element => {
      if(element.islogged){
        this.removeItemsCheckout(element['id']);
      }     
     });
   }

  isLoadPage(val){
    this.isLoad.next(val) ;
  }

  getPageStatus(): Observable<boolean> {
    return this.isLoad.asObservable();
  }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/shopping-cart.service.ts